import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchEntitlements(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('customer/entitlements', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteEntitlement(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`customer/entitlemens/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
